import { OrderItemType } from '@mews-commander/data-access';
import { OrderItem, ProductOrderItem } from '../index';

export type ProductOrderItemWithAgeCategory = ProductOrderItem & {
    data: ProductOrderItem['data'] & { value: { ageCategoryId: string } };
};

export type ProductOrderItemWithProductId = ProductOrderItem & {
    data: ProductOrderItem['data'] & { value: { productId: string } };
};

export const isProductOrderItem = (orderItem: OrderItem): orderItem is ProductOrderItem =>
    orderItem.data.discriminator === OrderItemType.ProductOrder;

export const isProductOrderItemWithAgeCategory = (orderItem: OrderItem): orderItem is ProductOrderItemWithAgeCategory =>
    isProductOrderItem(orderItem) && orderItem.data.value.ageCategoryId !== null;

export const isProductOrderItemWithProductId = (orderItem: OrderItem): orderItem is ProductOrderItemWithProductId =>
    isProductOrderItem(orderItem) && orderItem.data.value.productId !== null;
